import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttributeValidationError } from '../../section-instance/attribute-rows/attribute-number-edit-row/attribute-number-edit-row.component';

export interface StaticDropdownOption<T> {
  value: T;
  label: string;
}

export function getStaticDropdownError(value: unknown, isRequired: boolean): AttributeValidationError | null {
  return value == null && isRequired ? { key: 'COMMON.ATTRIBUTE_VALIDATION.REQUIRED' } : null;
}

@Component({
  selector: 'lib-static-dropdown-edit-row',
  standalone: false,
  templateUrl: './static-dropdown-edit-row.component.html',
  styleUrls: ['./static-dropdown-edit-row.component.scss'],
})
export class StaticDropdownEditRowComponent<T extends number | string | boolean> implements OnInit {
  @Input() label: string = '';
  @Input() options: StaticDropdownOption<T>[] = [];
  @Input() originalValue: T | null | undefined;
  @Input() value: T | null | undefined;
  @Input() isRequired: boolean = false;
  @Input() externalError: AttributeValidationError | null = null;
  @Output() valueChange = new EventEmitter<T | null>();
  selectedValue: T | null = null;
  error: AttributeValidationError | null = null;

  get shownError(): AttributeValidationError | null {
    return this.error ?? this.externalError;
  }

  ngOnInit(): void {
    this.selectedValue = (this.value === undefined ? this.originalValue : this.value) ?? null;
    this.validate(this.selectedValue);
  }

  onValueChange(value: T | null) {
    this.valueChange.emit(value);
    this.validate(value);
  }

  private validate(value: T | null) {
    this.error = value !== null && value === (this.originalValue ?? null)
      ? null
      : getStaticDropdownError(value, this.isRequired);
  }
}
